import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthProvider';
import styles from './ContentHeader.module.scss';

interface ContentHeaderProps {
    onMenuToggle: () => void;
    onThemeToggle?: () => void;
    isDarkTheme?: boolean;
}

export function ContentHeader({ onMenuToggle, onThemeToggle, isDarkTheme }: ContentHeaderProps) {
    const { user } = useAuth();
    const navigate = useNavigate();

    const avatarLetter = (user?.firstName || user?.email || '?')[0].toUpperCase();

    return (
        <header className={styles.header}>
            <button className={styles.menuButton} onClick={onMenuToggle} aria-label="Toggle menu">
                <span className={styles.hamburger}>
                    <span></span>
                    <span></span>
                    <span></span>
                </span>
            </button>

            <div className={styles.spacer} />

            <div className={styles.actions}>
                {onThemeToggle && (
                    <button
                        className={styles.themeButton}
                        onClick={onThemeToggle}
                        aria-label={isDarkTheme ? 'Switch to light mode' : 'Switch to dark mode'}
                    >
                        {isDarkTheme ? '☀️' : '🌙'}
                    </button>
                )}
                <button className={styles.avatar} onClick={() => navigate('/profile')} aria-label="View profile">
                    <span>{avatarLetter}</span>
                </button>
            </div>
        </header>
    );
}
